import Layout from "../TopNav/Topnav";
import { useTranslation } from "react-i18next";
import {
  Page,
  Card,
  Button,
  FormLayout,
  TextStyle,
  DropZone,
  Thumbnail,
  PageActions,
  Stack,
  Icon,
} from "@shopify/polaris";
import { CircleCancelMajor } from '@shopify/polaris-icons';
import { useParams } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { downloadPdf } from "./ConvertToPdf";
import MedicalHistoryPdfContent from "./MedicalHistoryPdfContent.js";
import PopUp from "../Common/Popup.js";
import Cookie from "js-cookie";
import instance from '../../util/axios';
import { PageDownMajor} from "@shopify/polaris-icons";
import { CircularProgress } from "@material-ui/core";

function AddMedicalHistoryPhotos() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [medicalConsentHistory , setMedicalConsentHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [previews, setPreviews] = useState([]);
  const hasPdfAlready = files.some((file) => file.type === "application/pdf");
  const cameraInputRef = useRef(null);
  const pdfRef = useRef();
  const [error ,setError] = useState("");
  const clinic_id = Cookie.get("clinic_id");
  const buttonStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    columnGap: "3px",
  };
  const handleDropZoneDrop = (_dropFiles, acceptedFiles, _rejectedFiles) => {
      const hasPdf = acceptedFiles.some(
        (file) => file.type === "application/pdf"
      );
      const hasImages = acceptedFiles.some((file) =>
        file.type.startsWith("image/")
      );


      if (hasPdf && hasImages) {
        setError("Cannot mix PDF and images. Please upload either a PDF or images, not both.");

        return;
      }

      if (hasPdf) {
        const pdfFile = acceptedFiles.find(
          (file) => file.type === "application/pdf"
        );
        setFiles([pdfFile]);
      } else if (hasImages) {
        if (hasPdfAlready) {
          setError("Only 1 PDF or multiple images allowed.");

          return;
        }
        setFiles((prev) => [...prev, ...acceptedFiles]);
        setError("");
      } else {
        setError("Unsupported file type(s).");

      }
    }


      const handleDelete = (index) => {
        setFiles((prev) => prev.filter((_, i) => i !== index));
      };

      const togglePopup = () => {
        setShowPopUp(!showPopUp);
      };

      const fetchMedicalConsent = async () => {
          try {
            setLoading(true);

            const res = await instance.get(
              `/admin/v1/provider/user-medical-consent-history/${id}`,
              {
                headers: {
                  Authorization: "Bearer " + Cookie.get("access_token_clinic"),
                },
              }
            );
            setMedicalConsentHistory(res.data);
          }catch (e) {
            console.error("Failed to fetch medical consent histories:", e);
          }finally {
          setLoading(false);
          }
        } 
      useEffect(() => {
        fetchMedicalConsent();
      }, [id]);
      
      const openFile = (e) => {
        const win = window.open(e.currentTarget.id, '_blank');
        win.focus();
      };
      useEffect(() => {
        const newPreviews = files.map((file) => URL.createObjectURL(file));
        setPreviews(newPreviews);
        return () => {
          newPreviews.forEach((url) => URL.revokeObjectURL(url));
        };
      }, [files]);

      const handleChange = (e) => {
        const newFiles = Array.from(e.target.files);
        const isImageInNewFiles = newFiles.some((file) => file.type.startsWith("image/"));
        const alreadyHasPdf = files.some((file) => file.type === "application/pdf");

        if (isImageInNewFiles && alreadyHasPdf) {
          setError("Only 1 PDF or multiple images allowed.");
          return;
        }

        if (isImageInNewFiles) {
          setFiles((prev) => [...prev, ...newFiles]);
          setError("");
        } else {
          setError("Unsupported file type from camera.");
        }
      };

  return (
    <Layout isProfile={true}>
      <Page
        title={t("Medical-Consent-Image")}
        breadcrumbs={[
          {
            url: `/dashboard/users/${id}`,
          },
        ]}
      >
        <Card sectioned>
          <FormLayout>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem"}}>
              <TextStyle variation="strong">
                {t("Upload")} {t("Medical-Consent-Image")}
              </TextStyle>
              { loading ? <CircularProgress style={{ color:" #fd2d42" }}/> : 
                (medicalConsentHistory?.data?.pdf_url &&
                  <Button
                      onClick={
                        (e) => openFile(e)
                      }
                      id={medicalConsentHistory?.data?.pdf_url}
                      primary
                      >
                      <div style={buttonStyle}>
                        <Icon source={PageDownMajor} color="base" />
                          View PDF
                      </div>

                  </Button>
                )
              }
            </div>
            <div
              style={{ display: "flex", gap: "2rem", alignItems: "flex-start" }}
            >
              <div style={{ width: "200px" }}>
                <DropZone
                  allowMultiple
                  onDrop={handleDropZoneDrop}
                  style={{ height: 160 }}
                >
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#888",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "2.5rem",
                        fontWeight: "bold",
                        lineHeight: 1,
                      }}
                    >
                      +
                    </span>
                  </div>
                </DropZone>
            {error && <p style={{ color: "red", fontWeight: "bold" }}>ERROR: {error}</p>}

              </div>


              <div style={{ flexGrow: 1 }}>
                <Stack spacing="tight">
                  {files.map((file, index) => (
                    <div
                      key={index}
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <Thumbnail
                        size="large"
                        source={previews[index]}
                        alt={file.name}
                      />
                      <div
                        onClick={() => handleDelete(index)}
                        style={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: "#fff",
                          borderRadius: "50%",
                          cursor: "pointer",
                          boxShadow: "0 0 3px rgba(0,0,0,0.3)",
                        }}
                      >
                        <Icon source={CircleCancelMajor} color="critical" />
                      </div>
                    </div>
                  ))}
                </Stack>
              </div>
            </div>
          </FormLayout>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "1.5rem",
            }}
          >
            <button
              onClick={() => cameraInputRef.current?.click()}
              style={{
                backgroundColor: "transparent",
                color: "#5c6ac4",
                border: "2px solid #5c6ac4",
                padding: "0.6rem 1.2rem",
                borderRadius: "4px",
                fontWeight: "600",
                cursor: "pointer",
                minWidth: "120px",
              }}
            >
              {t("Take-Photo")}
            </button>
            <button
              onClick={togglePopup}
              style={{
                backgroundColor: "#fe2c45",
                color: "white",
                padding: "0.6rem 1.2rem",
                border: "none",
                borderRadius: "4px",
                fontWeight: "600",
                cursor: "pointer",
                minWidth: "120px",
              }}
            >
              {t("Continue")}
            </button>

            <input
              id="cameraInput"
              type="file"
              accept="image/*"
              ref={cameraInputRef}
              multiple
              capture="environment"
              onChange={handleChange}
              style={{ display: "none" }}
            />
            <PopUp
              open={showPopUp}
              closePopUp={() => setShowPopUp(false)}
             onConfirm={async () => {
              try {
                setLoading(true);
                const blob = await downloadPdf({
                  files,
                  user_id: id,
                  clinic_id,
                  element: pdfRef.current
                });
                if (blob){
                  setShowPopUp(false);
                  await fetchMedicalConsent();
                } 
              } catch (e) {
                console.error(e);
              }finally {
                setLoading(false);
                setError(false);
              }}
            }
              loading={loading}
            >
             <div ref={pdfRef} style={{ display: 'block' }}>
              <MedicalHistoryPdfContent files={files} />
            </div>
            </PopUp>
          </div>
        </Card>
      </Page>
    </Layout>
  );
}

export default AddMedicalHistoryPhotos;